<template>
  <div class="u-wrap">
    <div class="heard">
      <van-tabs v-model="currentTab" @change="change" color="#3E78F7" line-width="70px">
        <van-tab v-for="(item, index) in tabList" :key="index" :title="item.text"></van-tab>
      </van-tabs>
    </div>
    <div class="u-content-wrap">
      <van-empty v-if="dataList.length == 0" style="width: 100%" description="暂无数据" />
      <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
          <div class="ul">
            <div class="zxks-card" v-for="(item, index) in dataList" :key="index" @click="clickItem(item)">
              <div class="title u-line-2">{{ item.ksmc }}</div>
              <div class="time">
                {{ item.kssj }}~{{ item.jzsj }}
                <span v-if="currentTab == 1" class="fs">{{ item.dtcj }}分</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import { matchType } from '@/utils/util'

export default {
  data() {
    return {
      currentTab: 0,
      tabList: [{ text: '待答' }, { text: '已答' }],
      dataList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      type: '01',
      status: '03',
    }
  },
  created() {
    this.onRefresh()
  },
  computed: {},
  methods: {
    change(index) {
      this.dataList = [];
      this.onRefresh()
    },
    getWdt() {
      let params = { pageNo: this.pageNo }
      getAction('/yqfk/kshd/page/wdt', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
            this.refreshing = false
          }
          let list = res.result.records
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        }
      })
    },
    getYdt() {
      let params = { pageNo: this.pageNo }
      getAction('/yqfk/kshd/page/ydt', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
            this.refreshing = false
          }
          let list = res.result.records
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageNo++

      if (this.currentTab == 0) {
        this.getWdt()
      } else {
        this.getYdt()
      }
    },
    clickItem(item) {
      if(this.currentTab==0){
         let params = {
            id: item.id
          }
          this.$router.push({
            path: '/dqfw/zxdt-view',
            query: params,
          })
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 44px;
  background-color: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}
.ul {
  box-sizing: border-box;
  padding: 8px 12px;
  width: 100vw;
}

.zxks-card {
  background: #fff;
  border-radius: 5px;
  padding-bottom: 0;
  margin-bottom: 10px;
  box-shadow: 0px 1px 8px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  padding: 10px;
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 15px;
}

.time {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fs {
  margin-left: auto;
  color: #ff9900;
  font-size: 18px;
}
</style>
